export default __webpack_public_path__ + "c297f5cdaaeb8096c2aba40f3b0e8354.svg";